// Basic
import PropTypes from 'prop-types';
// Components
import {
    DropdownMenu,
    DropdownMenuTrigger
} from '../../ui/dropdown-menu';
import { Button } from '../../ui/button';
import DropdownContent from './DropdownContent';


/**
 * @param root0
 * @param root0.actions
 * @param root0.trigger
 * @param root0.triggerValues
 * @param root0.side
 * @param root0.align
 * @param root0.dataCy
 * @returns {JSX}
 */
function Dropdown({ actions, trigger, triggerValues, side, align, dataCy }) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild disabled={actions.filter(action => action.visible).length === 0 || trigger?.props?.disabled}>
                {
                    trigger || <Button variant={triggerValues.variant} icon={triggerValues.icon} title={triggerValues.title} data-cy={dataCy} />
                }
            </DropdownMenuTrigger>
            <DropdownContent actions={actions} side={side} align={align} />
        </DropdownMenu >
    );
}

Dropdown.propTypes = {
    actions: PropTypes.array.isRequired,
    trigger: PropTypes.node,
    triggerValues: PropTypes.object,
    side: PropTypes.string,
    align: PropTypes.string,
    dataCy: PropTypes.string
};

export default Dropdown;